import React from "react";

/**
 * MonthPicker — selects separados Mês + Ano, confiável em qualquer celular.
 * Props:
 *   value: "YYYY-MM"
 *   onChange: (newValue: "YYYY-MM") => void
 *   testid?: string prefix
 *   fromYear?: number (default: currentYear - 10)
 *   toYear?: number (default: currentYear + 1)
 */
const MONTHS_PT = [
  "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
  "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro",
];

export default function MonthPicker({ value, onChange, testid = "month-picker", fromYear, toYear }) {
  const now = new Date();
  const [y, m] = (value || "").split("-");
  const year = parseInt(y, 10) || now.getFullYear();
  const month = parseInt(m, 10) || now.getMonth() + 1;

  const minYear = fromYear ?? (now.getFullYear() - 10);
  const maxYear = toYear ?? (now.getFullYear() + 1);
  const years = [];
  for (let i = maxYear; i >= minYear; i--) years.push(i);

  const emit = (newY, newM) => {
    const mm = String(newM).padStart(2, "0");
    onChange(`${newY}-${mm}`);
  };

  const selectCls = "min-w-0 h-10 rounded-lg border border-slate-200 bg-white text-sm font-semibold text-slate-700 px-2 pr-7 focus:outline-none focus:ring-2 focus:ring-violet-400";

  return (
    <div className="flex items-center gap-2">
      <select
        value={month}
        onChange={(e) => emit(year, parseInt(e.target.value, 10))}
        className={`${selectCls} flex-1`}
        data-testid={`${testid}-month`}
      >
        {MONTHS_PT.map((label, idx) => (
          <option key={idx + 1} value={idx + 1}>{label}</option>
        ))}
      </select>
      <select
        value={year}
        onChange={(e) => emit(parseInt(e.target.value, 10), month)}
        className={`${selectCls} w-24`}
        data-testid={`${testid}-year`}
      >
        {years.map((y) => (
          <option key={y} value={y}>{y}</option>
        ))}
      </select>
    </div>
  );
}
